import { render, staticRenderFns } from "./addEditDialog.vue?vue&type=template&id=a88bfba2&scoped=true"
import script from "./addEditDialog.vue?vue&type=script&lang=js"
export * from "./addEditDialog.vue?vue&type=script&lang=js"
import style0 from "./addEditDialog.vue?vue&type=style&index=0&id=a88bfba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88bfba2",
  null
  
)

export default component.exports